import { AllEmployeeDetailsDto } from "./EmployeeAction";
import {
    EMPLOYEE_GET_ALL,
    EMPLOYEE_SET_FILTERS,
    EMPLOYEE_CLEAR_FILTERS,
    EMPLOYEE_SET_STATE,
    EMPLOYEE_PAGE_RESET,
    EMPLOYEE_SET_LOADING,
    EMPLOYEE_SET_ERROR,
    EMPLOYEE_CLEAR_ERROR,
    EMPLOYEE_DETAILS_SUCCESS,
    EMPLOYEE_DETAILS_FAILURE,
    EMPLOYEE_SET_SELECTED,
    EMPLOYEE_MANAGE_REQUEST,
    EMPLOYEE_MANAGE_SUCCESS,
    EMPLOYEE_MANAGE_FAILURE,
    EMPLOYEE_DETAILS_RESET
} from "./EmployeeActionType";

// Initial state
const initialState = {
    records: [],           // Employee records
    filteredRecords: [],   // Filtered employee records
    selectedEmployee: null,   // Currently selected employee record
    filters: {
        Department: null,
        Status: null,
        EmploymentType: null,
        Designation: null,
        JoinDateFrom: null,
        JoinDateTo: null,
        SearchTerm: null
    },
    statistics: {
        totalEmployees: 0,
        activeEmployees: 0,
        inactiveEmployees: 0,
        onLeaveEmployees: 0,
        resignedEmployees: 0,
        terminatedEmployees: 0,
        employeesByDepartment: {},
        employeesByDesignation: {},
        employeesByStatus: {}
    },
    loading: false,
    error: null,
    manageStatus: {
        loading: false,
        success: false,
        error: null,
        indicator: null,
        message: null,
        response: null,
        id: null,
        employeeId: null,
        employeeCode: null
    },
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0
    },
    lastOperation: null
};

const EmployeeReducer = (state = initialState, action: any) => {
    switch (action.type) {
        
        case EMPLOYEE_DETAILS_SUCCESS:
            console.log("========== REDUCER: EMPLOYEE_DETAILS_SUCCESS ==========");
            console.log("Action type:", action.type);
            console.log("Action payload:", action.payload);
            console.log("Payload type:", typeof action.payload);
            console.log("Is payload array?", Array.isArray(action.payload));
            console.log("Payload length:", Array.isArray(action.payload) ? action.payload.length : 'Not an array');
            
            if (Array.isArray(action.payload) && action.payload.length > 0) {
                console.log("First record in payload:", action.payload[0]);
                console.log("All fields in first record:", Object.keys(action.payload[0]));
                console.log("Sample data - employeeCode:", action.payload[0].employeeCode);
                console.log("Sample data - employeeName:", action.payload[0].employeeName);
                console.log("Sample data - email:", action.payload[0].email);
            } else {
                console.log("Payload is empty or not an array");
            }
            
            console.log("==================================================");
            
            return {
                ...state,
                records: action.payload || [],
                filteredRecords: action.payload || [], // Show all records, no filtering
                pagination: {
                    ...state.pagination,
                    totalItems: action.payload?.length || 0,
                    totalPages: Math.ceil((action.payload?.length || 0) / state.pagination.itemsPerPage)
                },
                loading: false,
                error: null
            };
            
        case EMPLOYEE_DETAILS_FAILURE:
            console.log("========== REDUCER: EMPLOYEE_DETAILS_FAILURE ==========");
            console.log("Error payload:", action.payload);
            console.log("==================================================");
            return {
                ...state,
                loading: false,
                error: action.payload
            };
            
        case EMPLOYEE_SET_FILTERS:
            console.log("========== REDUCER: EMPLOYEE_SET_FILTERS ==========");
            console.log("Filters applied:", action.payload);
            console.log("Current records count:", state.records.length);
            console.log("==================================================");
            
            // Just update filters but DON'T filter the records - show all records
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                },
                // Keep filteredRecords as all records (no filtering)
                filteredRecords: state.records,
                pagination: {
                    ...state.pagination,
                    currentPage: 1,
                    totalItems: state.records.length,
                    totalPages: Math.ceil(state.records.length / state.pagination.itemsPerPage)
                }
            };
            
        case EMPLOYEE_CLEAR_FILTERS:
            console.log("========== REDUCER: EMPLOYEE_CLEAR_FILTERS ==========");
            console.log("Filters cleared");
            console.log("==================================================");
            
            return {
                ...state,
                filters: {
                    Department: null,
                    Status: null,
                    EmploymentType: null,
                    Designation: null,
                    JoinDateFrom: null,
                    JoinDateTo: null,
                    SearchTerm: null
                },
                filteredRecords: state.records, // Show all records
                pagination: {
                    ...state.pagination,
                    currentPage: 1,
                    totalItems: state.records.length,
                    totalPages: Math.ceil(state.records.length / state.pagination.itemsPerPage)
                }
            };
            
        case EMPLOYEE_SET_SELECTED:
            return {
                ...state,
                selectedEmployee: action.payload
            };
            
        case EMPLOYEE_SET_STATE:
            return {
                ...state,
                ...action.payload
            };
            
        case EMPLOYEE_SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
            
        case EMPLOYEE_SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
            
        case EMPLOYEE_CLEAR_ERROR:
            return {
                ...state,
                error: null
            };
            
        case EMPLOYEE_MANAGE_REQUEST:
            console.log("========== REDUCER: EMPLOYEE_MANAGE_REQUEST ==========");
            console.log("Manage request:", action.payload);
            console.log("==================================================");
            
            return {
                ...state,
                manageStatus: {
                    loading: true,
                    success: false,
                    error: null,
                    indicator: action.payload?.indicator,
                    message: null,
                    response: null,
                    id: null,
                    employeeId: null,
                    employeeCode: null
                },
                lastOperation: {
                    type: 'REQUEST',
                    indicator: action.payload?.indicator,
                    timestamp: new Date().toISOString()
                }
            };
            
        case EMPLOYEE_MANAGE_SUCCESS:
            console.log("========== REDUCER: EMPLOYEE_MANAGE_SUCCESS ==========");
            console.log("Manage success response:", action.payload);
            console.log("Indicator:", state.manageStatus.indicator);
            console.log("==================================================");
            
            let successMessage = action.payload.message;
            const indicator = state.manageStatus.indicator;
            
            if (!successMessage) {
                if (indicator === 'I') successMessage = 'Employee inserted successfully';
                else if (indicator === 'U') successMessage = 'Employee updated successfully';
                else if (indicator === 'D') successMessage = 'Employee deactivated successfully';
                else successMessage = 'Operation completed successfully';
            }
            
            return {
                ...state,
                manageStatus: {
                    loading: false,
                    success: true,
                    error: null,
                    indicator: indicator,
                    message: successMessage,
                    response: action.payload,
                    id: action.payload.id,
                    employeeId: action.payload.employeeId,
                    employeeCode: action.payload.employeeCode
                },
                lastOperation: {
                    type: 'SUCCESS',
                    indicator: indicator,
                    message: successMessage,
                    data: {
                        id: action.payload.id,
                        employeeId: action.payload.employeeId,
                        employeeCode: action.payload.employeeCode
                    },
                    timestamp: new Date().toISOString()
                }
            };
            
        case EMPLOYEE_MANAGE_FAILURE:
            console.log("========== REDUCER: EMPLOYEE_MANAGE_FAILURE ==========");
            console.log("Manage failure:", action.payload);
            console.log("==================================================");
            
            const errorIndicator = state.manageStatus.indicator;
            const errorMsg = action.payload?.message || 
                            (errorIndicator === 'I' ? 'Failed to insert employee' :
                             errorIndicator === 'U' ? 'Failed to update employee' :
                             errorIndicator === 'D' ? 'Failed to delete employee' :
                             'Failed to process employee request');
            
            return {
                ...state,
                manageStatus: {
                    loading: false,
                    success: false,
                    error: action.payload,
                    indicator: errorIndicator,
                    message: errorMsg,
                    response: null,
                    id: null,
                    employeeId: null,
                    employeeCode: null
                },
                lastOperation: {
                    type: 'FAILURE',
                    indicator: errorIndicator,
                    message: errorMsg,
                    error: action.payload,
                    timestamp: new Date().toISOString()
                }
            };
            
        case EMPLOYEE_DETAILS_RESET:
        case EMPLOYEE_PAGE_RESET:
            console.log("========== REDUCER: EMPLOYEE_DETAILS_RESET ==========");
            console.log("Resetting to initial state");
            console.log("==================================================");
            
            return {
                ...initialState
            };
            
        default:
            return state;
    }
};

export default EmployeeReducer;